<template>
  <div class="app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row v-for="item in 3" :key="item">
        <v-col>
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form v-show="!showSkeleton" ref="form">
      <v-row>
        <v-col cols="4">
          <v-text-field
            dense
            v-model="form.inicio"
            :error-messages="inicioErrors"
            :counter="10"
            label="Início do Range"
            type="number"
            outlined
            @input="$v.form.inicio.$touch()"
            @blur="$v.form.inicio.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            dense
            v-model="form.quantidade"
            :error-messages="quantidadeErrors"
            :counter="2"
            type="number"
            label="Quantidade"
            outlined
            @input="$v.form.quantidade.$touch()"
            @blur="$v.form.quantidade.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.grupoCaptura"
            :items="grupoCapturaDisponiveis"
            label="Grupo de Captura"
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-select
            dense
            v-model="form.webrtc"
            :items="tipoRamal"
            label="Transporte"
            outlined
          />
        </v-col>
      </v-row>
      <DraggAndDrop
        dragname="Codecs"
        :valoresDisponiveisComboBox="codecs.codecsDisponiveis"
        @dragUpdate="updateCodecs($event)"
        :opcoes-selecionadas="codecs.codecsSelecionadas"
        :canRender = "!form.webrtc"
      />
      <DraggAndDrop
        dragname="Rotas"
        :valoresDisponiveisComboBox="rotasGerais.rotasGeralDisponiveis"
        @dragUpdate="updateRotasGeral($event)"
        :opcoesSelecionadas="rotasGerais.rotasGeralSelecionadas"
      />
      <DraggAndDrop
        dragname="Rotas de Transferência"
        :valoresDisponiveisComboBox="rotasTransferencias.rotasTransferenciasDisponiveis"
        @dragUpdate="updateRotasTransferencia($event)"
        :opcoesSelecionadas="rotasTransferencias.rotasTransferenciasSelecionadas"
      />

      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule, formatarRota } from '@/utils/vuexUtils'
import { ordenar } from '@/utils/ordenarArrayByText'

import ramaisStore from '../_store'
import DraggAndDrop from '../_components/DraggAndDrop'
import { validateData, validateComputed } from '../_validates/validatesPjsipMultiplos'
import RamaisHttpService from '../_services/RamaisHttpService'

export default {
  name: 'AbaRamalPjsipMultiplos',
  components: { DraggAndDrop, Snackbar, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      inicio: '',
      quantidade: '',
      tipo: 'PJSIP',
      grupoCaptura: '',
      codecs: [],
      rotasTransferencias: [],
      rota: [],
      webrtc: false,
    },

    rotasTransferencias: {
      rotasTransferenciasDisponiveis: [],
      rotasTransferenciasSelecionadas: [],
    },
    rotasGerais: {
      rotasGeralDisponiveis: [],
      rotasGeralSelecionadas: [],
    },
    grupoCapturaDisponiveis: [],
    codecs: {
      codecsDisponiveis: ['alaw', 'ulaw', 'gsm', 'g729', 'h263', 'h264'],
      codecsSelecionadas: [],
    },
    item: -1,
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
    tipoRamal:[
      {
        text:"Padrão",
        value:false,
      },
      {
        text:"WEBRTC",
        value:true,
      }
    ],
  }),
  validations: {
    ...validateData,
  },
  computed: {
    ...mapGetters('abaRamalPJSIPMultiplosModulePABXStore', ['getRotasDisponiveis', 'getGrupos']),
    ...validateComputed,
  },
  async created() {
    registerVuexModule(this.$store, 'abaRamalPJSIPMultiplosModulePABXStore', ramaisStore)

    await Promise.all([this.listarRotas(), this.listarGrupo()])

    this.rotasTransferencias.rotasTransferenciasDisponiveis = [...this.getRotasDisponiveis]
    this.rotasGerais.rotasGeralDisponiveis = [...this.getRotasDisponiveis]

    this.rotasGerais.rotasGeralSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)
    this.rotasTransferencias.rotasTransferenciasSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)

    this.getGrupos.forEach(grupo => {
      if (grupo.tipo === 'GRUPOCAPTURA') {
        this.grupoCapturaDisponiveis.push({ text: grupo.description, value: grupo._id })
      }
      if (grupo.default) {
        this.form.grupoCaptura = grupo._id
      }
    })

    this.codecs.codecsSelecionadas.push('alaw', 'ulaw', 'gsm')

    ordenar(this.rotasTransferencias.rotasTransferenciasDisponiveis)
    ordenar(this.rotasGerais.rotasGeralDisponiveis)
    ordenar(this.codecs.codecsDisponiveis)
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('abaRamalPJSIPMultiplosModulePABXStore', ['listarRotas', 'listarGrupo']),
    updateCodecs(event) {
      this.form.codecs = event
    },
    updateRotasGeral(event) {
      this.form.rota = formatarRota(event)
    },
    updateRotasTransferencia(event) {
      this.form.rotaTransferencia = formatarRota(event)
    },
    async salvar() {
      this.pararLoader.parar = false

      if (!this.form.codecs.length) {
        this.text = 'Nenhum codec Selecionado'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }
      if (!this.form.rota['1']) {
        this.text = 'Nenhuma rota selecionada.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }
      if (!this.form.rotaTransferencia['1']) {
        this.text = 'Nenhuma rota de transferência selecionada.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      try {
        await RamaisHttpService.postRamaisMultiplos(this.form)
        this.$router.push({ name: 'Ramais' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Ramais' })
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
